import { EFinancingProgram } from '@if/core/types'
import { ComputeMechanicalWarrantyRequestDto } from '@src/types/ComputeMechanicalWarrantyRequestDto'
import { ComputeMechanicalWarrantyResultDto } from '@src/types/ComputeMechanicalWarrantyResultDto'
import { ProductsComputeRequestDto } from '@src/types/ProductsComputeRequestDto'
import { ProductsComputeResultDto } from '@src/types/ProductsComputeResultDto'
import { QueryFunctionContext, useQuery } from '@tanstack/react-query'
import { getApiClient } from '../api-client'

const SCOPE = 'calculator-rate'
const CALCULATE = 'calculate'

const keysFactory = {
  computeProductsLoan: (calculator: ProductsComputeRequestDto | undefined) =>
    [{ scope: SCOPE, entity: CALCULATE, calculator }] as const,
  computeMechanicalWarrantyLoan: (calculator: ComputeMechanicalWarrantyRequestDto | undefined) =>
    [{ scope: SCOPE, entity: CALCULATE, calculator }] as const,
}

const computeProductsLoan = async (
  _ctx: QueryFunctionContext<ReturnType<(typeof keysFactory)['computeProductsLoan']>>,
  calculator: ProductsComputeRequestDto | undefined,
) => {
  const apiClient = getApiClient()

  const response = await apiClient.post<ProductsComputeResultDto>(
    `/${EFinancingProgram.Products}/Calculator/Compute`,
    calculator,
  )

  return response.data
}

const useComputeProductsLoan = (
  dto: ProductsComputeRequestDto | undefined,
): [ProductsComputeResultDto | null, boolean] => {
  const { isFetching, data } = useQuery({
    queryKey: keysFactory.computeProductsLoan(dto),
    queryFn: (ctx) => computeProductsLoan(ctx, dto),
    enabled: !!dto,
  })

  return [data ?? null, isFetching]
}


const computeMechanicalWarrantyLoan = async (
  _ctx: QueryFunctionContext<ReturnType<(typeof keysFactory)['computeMechanicalWarrantyLoan']>>,
  calculator: ComputeMechanicalWarrantyRequestDto | undefined,
) => {
  const apiClient = getApiClient()

  const response = await apiClient.post<ComputeMechanicalWarrantyResultDto>(
    `/Calculator/${EFinancingProgram.MechanicalWarranty}/Compute`,
    calculator,
  )

  return response.data
}

const useComputeMechanicalWarrantyLoan = (
  dto: ComputeMechanicalWarrantyRequestDto | undefined,
): [ComputeMechanicalWarrantyResultDto | null, boolean] => {
  const { isFetching, data } = useQuery({
    queryKey: keysFactory.computeMechanicalWarrantyLoan(dto),
    queryFn: (ctx) => computeMechanicalWarrantyLoan(ctx, dto),
    enabled: !!dto,
  })

  return [data ?? null, isFetching]
}

export { useComputeMechanicalWarrantyLoan, useComputeProductsLoan }

